module.exports = __webpack_public_path__ + "static/isaoshimizu-7ae18cf272b8a03ad335c6f93b62a40f.jpg";